import { ChangeEventHandler } from 'react';

import { FormControl, TextField } from '@mui/material';
import { editDrawerTextFieldStyles } from 'common/utils/StyleHelpers';

export type ClaimValueCustomTextFieldProps = {
    value: string,
    changeHandler: ChangeEventHandler<HTMLTextAreaElement | HTMLInputElement>,
    hasError?: boolean
};

export function ClaimValueCustomTextField({
    value,
    changeHandler,
    hasError
}: Readonly<ClaimValueCustomTextFieldProps>) {
    return (
        <FormControl>
            <TextField
                sx={editDrawerTextFieldStyles(hasError)}
                size="small"
                label="Claim Value"
                placeholder="Type Claim Value"
                variant="filled"
                value={value}
                onChange={changeHandler}
            />
        </FormControl>
    );
}
